import React from 'react';
import DaumPostcodeEmbed from 'react-daum-postcode';

type Props = {
    onSelect: (fullAddress: string, zipcode: string) => void;
    onCloseModal: () => void;
};

export default function GetSearchAddress({ onSelect, onCloseModal }: Props) {
    const handleComplete = (data) => {
        let fullAddress = data.address;
        let zipcode = data.zonecode;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }
        console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
        onSelect(fullAddress, zipcode);
        onCloseModal();
    };

    return (
        <div style={{ width: '100%', height: '400px' }}>
            <DaumPostcodeEmbed onComplete={handleComplete} style={{ width: '100%', height: '100%' }} />
        </div>
    );
}